import React from 'react'
import { IContentLoaderProps } from 'react-content-loader'
import ContentLoader from './ContentLoader'

const StoryContentPlaceholder: React.FC<IContentLoaderProps> = (props): JSX.Element => {
	const isMobView = window.innerWidth < 768

	return (
		<ContentLoader height={800} width="100%" viewBox="0 0 1200 800" {...props}>
			<rect x="0" y="50" rx="6" ry="6" width="165" height="16" />
			<rect x="0" y="90" rx="6" ry="6" width="900" height="6" />
			<rect x="0" y="110" rx="6" ry="6" width="804" height="6" />
			<rect x="0" y="130" rx="6" ry="6" width="604" height="6" />
			<rect x="0" y="150" rx="6" ry="6" width="304" height="6" />
			<rect x="0" y="170" rx="6" ry="6" width="800" height="6" />

			{isMobView ? (
				<rect x="0" y="199" rx="6" ry="6" width="1200" height="320" />
			) : (
				<>
					<rect x="0" y="199" rx="6" ry="6" width="610" height="320" />
					<rect x="620" y="199" rx="6" ry="6" width="450" height="320" />
					<rect x="1080" y="199" rx="6" ry="6" width="320" height="320" />
				</>
			)}

			<rect x="0" y="543" rx="6" ry="6" width="250" height="16" />
			<rect x="322" y="543" rx="6" ry="6" width="854" height="6" />
			<rect x="322" y="563" rx="6" ry="6" width="804" height="6" />
			<rect x="322" y="583" rx="6" ry="6" width="604" height="6" />
			<rect x="322" y="603" rx="6" ry="6" width="304" height="6" />
		</ContentLoader>
	)
}

export default StoryContentPlaceholder
